import {
  CREATE_STEP_FAIL,
  CREATE_STEP_PENDING,
  CREATE_STEP_SUCCESS,
  UPDATE_STEP_FAIL,
  UPDATE_STEP_PENDING,
  UPDATE_STEP_SUCCESS,
  GET_STEPS_FAIL,
  GET_STEPS_SUCCESS,
  GET_STEPS_PENDING,
  DESTROY_STEP,
} from '../actions/stepActions';


const initialState = {
  step: {
    loading: false,
    loaded: false,
    id: null,
    send_from_launch_duration: null,
    status: null,
  },
  steps: {
    results: [],
  },
};

export const stepReducer = (state = initialState.step, action) => {
  switch (action.type) {
    case CREATE_STEP_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_STEP_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_STEP_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_STEP_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case UPDATE_STEP_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_STEP_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};


export const stepsReducer = (state = initialState.steps, action) => {
  switch (action.type) {
    case GET_STEPS_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_STEPS_FAIL:
      return {
        loading: false,
        loaded: true,
        results: [],
        ...action.payload,
      };
    case GET_STEPS_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case DESTROY_STEP.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case DESTROY_STEP.error:
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    case DESTROY_STEP.success:
      return {
        loading: false,
        loaded: true,
        results: state.results.filter(id => id !== action.payload.id),
      };
    default:
      return state;
  }
};
